export const publicSiteContent = {
  creatorName: 'PawerLifting creator',
  about: 'I am a female developer and recreational lifter based in Germany. I am building PawerLifting independently in my free time to make strength training feel calmer, clearer and more personal.',
  socials: [
    { label: 'Instagram', url: process.env.REACT_APP_INSTAGRAM_URL || '' },
    { label: 'Telegram', url: process.env.REACT_APP_TELEGRAM_URL || '' },
  ],
};
